import EmployeeInformationWidget from './EmployeeInformationWidget';

export default EmployeeInformationWidget;
